<template>
  <div class="disision">
    <el-cascader
      expand-trigger="hover"
      :options="options"
      :props="props"
      v-model="selectedOptions2"
      @change="handleChange"
      :change-on-select="true"
      :show-all-levels="false"
    ></el-cascader>
  </div>
</template>

<script>
import { CantonMgeSvr } from '@/service/CantonMgeSvr';
import { mapState } from 'vuex';
import { division } from '@/assets/js/division';

export default {
  components: {},
  props: {
    defvalue:String,
    // value:Object
  },
  watch:{
    defvalue:{
      handler(val){
        this.selectedOptions2.push(val);
      }
    }
  },
  data() {
    return {
      options: [],
      selectedOptions2: [],
      props: {
        value: 'CantonCode',
        label: 'CantonName',
        children: 'Childs'
      }
    };
  },
  created() {
    this.cantonMgeSvr = new CantonMgeSvr();
  },
  computed: {
    ...mapState(['token'])
  },
  mounted() {
    this.cantonMgeSvr.GetCanton(this.token, division, true).then(res => {
      this.options = this.dealOption(res.Childs._Items);
    });
  },
  methods: {
    handleChange(value) {
      this.$emit('input', value[0]);
    },
    dealOption(option) {
      for (let i = 0; i < option.length; i++) {
        if (option[i].Childs._Items.length > 0) {
          option[i].Childs = option[i].Childs._Items;
          if (option[i].Childs.length > 0) {
            this.dealOption(option[i].Childs);
          }
        } else {
          option[i].Childs = null;
        }
      }
      return option;
    }
  }
};
</script>
<style lang="scss" scoped>
.disision {
  .el-cascader {
    width: 100%;
  }
}
</style>